export default __webpack_public_path__ + "static/media/pic1.1639d73e.jpg";